import React, { FunctionComponent } from 'react';
import { _t } from 'app/utils/i18n';

import styles from './NoData.module.scss';

interface Props {
  noDataMsg?: string;
}

const NoData: FunctionComponent<Props> = ({ noDataMsg }) => {
  return (
    <div className={styles.NoData} data-testid="no-data">
      {noDataMsg ? noDataMsg : _t('basic:no_data')}
    </div>
  );
};

export default NoData;
